import { render } from "./CRMDashboardView.vue?vue&type=template&id=3f9e6e44"
import script from "./CRMDashboardView.vue?vue&type=script&lang=js"
export * from "./CRMDashboardView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__